export default "__VITE_ASSET__BvvfmV9P__"